import { render, staticRenderFns } from "./indexOneVip.vue?vue&type=template&id=544aaef5&scoped=true"
import script from "./indexOneVip.vue?vue&type=script&lang=js"
export * from "./indexOneVip.vue?vue&type=script&lang=js"
import style0 from "./indexOneVip.vue?vue&type=style&index=0&id=544aaef5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544aaef5",
  null
  
)

export default component.exports